<template>
  <v-container fluid ma-0 pa-0 fill-height class="justify-center">
    <v-container v-if="!userdata" class="justify-center flex-column">
      <v-progress-linear
        indeterminate
        color="yellow darken-2"
      ></v-progress-linear>
      <br />
      <v-progress-linear indeterminate color="orange"></v-progress-linear>
      <br />
    </v-container>
    <v-data-table
      :headers="headers"
      :items="userdata"
      item-key="user_id"
      :loading="myloadingvariable"
      loading-text="Loading... Bitte warten"
      @current-items="datenSum"
      loader-height="0"
      fixed-header
      :height="height - 100"
    >
      <template v-slot:top>
        <!-- v-container, v-col and v-row are just for decoration purposes. -->
        <v-container fluid>
          <v-row>
            <v-col cols="3">
              <v-row class="pa-3">
                <v-text-field
                  v-model="nameFilterValue"
                  type="text"
                  label="Name"
                  append-icon="mdi-magnify"
                ></v-text-field>
              </v-row>
            </v-col>
            <v-col cols="3">
              <v-row class="pa-3">
                <v-select
                  :items="department"
                  v-model="departmentFilterValue"
                  label="Abteilung"
                ></v-select>
              </v-row>
            </v-col>
            <v-col cols="3">
              <v-row class="pa-3">
                <v-select
                  :items="skills"
                  v-model="skillFilterValue"
                  label="Skills"
                ></v-select>
              </v-row>
            </v-col>
            <v-col cols="3">
              <v-row class="pa-3">
                <v-select
                  :items="shows"
                  v-model="show"
                  label="Darstellen"
                  v-on:change="changeShow"
                ></v-select>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
        <v-dialog v-model="dialog" max-width="800px">
          <diagramm-item :data="diagrammItem"></diagramm-item
        ></v-dialog>
      </template>

      <template v-slot:item="{ item }">
        <tr class="orange lighten-4">
          <td>{{ item.name }}</td>
          <td>{{ item.department }}</td>
          <td>
            <v-chip color="deep-orange" dark>
              {{ item.skill }}
            </v-chip>
          </td>
          <td class="blue-grey lighten-4">soll_daten</td>
          <td
            class="blue-grey lighten-4"
            v-for="(month, index) in item.soll_daten"
          >
            {{ month }}
          </td>
          <td class="blue-grey lighten-3">
            {{
              item.soll_daten.reduce(function (pv, cv) {
                return pv + cv;
              }, 0)
            }}
          </td>
        </tr>
        <tr>
          <td></td>
          <td>
            <v-icon small class="mr-2" color="orange" @click="diagramm(item)">
              mdi-chart-line
            </v-icon>
          </td>
          <td></td>
          <td>ist_daten</td>

          <td v-for="(month, index) in item.forecast_daten">{{ month }}</td>
          <td>
            {{
              item.forecast_daten.reduce(function (pv, cv) {
                return pv + cv;
              }, 0)
            }}
          </td>
        </tr>
      </template>
      <template slot="body.append">
        <tr class="white--text blue-grey darken-3">
          <td></td>
          <td>Soll Arbeitsstunden pro Tag</td>

          <td></td>
          <td></td>
          <td v-for="month in this.soll_datenSum">{{ month }}</td>
          <td class="blue-grey darken-1">
            {{
              soll_datenSum.reduce(function (pv, cv) {
                return pv + cv;
              }, 0)
            }}
          </td>
        </tr>
        <tr class="white--text blue-grey darken-3">
          <td></td>
          <td>ist Arbeitsstunden pro Tag</td>

          <td></td>

          <td></td>

          <td v-for="month in ist_datenSum">{{ month }}</td>
          <td class="blue-grey darken-1">
            {{
              ist_datenSum.reduce(function (pv, cv) {
                return pv + cv;
              }, 0)
            }}
          </td>
        </tr>
        <tr class="white--text orange darken-4">
          <td></td>
          <td>Soll-Erreichung in %</td>

          <td></td>

          <td></td>

          <td v-for="month in precent_data">{{ Math.round(month) }} %</td>
          <td class="orange lighten-1">
            {{
              Math.round(
                (ist_datenSum.reduce(function (pv, cv) {
                  return pv + cv;
                }, 0) *
                  100) /
                  soll_datenSum.reduce(function (pv, cv) {
                    return pv + cv;
                  }, 0)
              )
            }}
            %
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Anzahl. Arbeitstage S.A</td>

          <td></td>

          <td></td>

          <td v-for="month in workDays">{{ month }}Tage</td>
          <td class="">
            {{
              workDays.reduce(function (pv, cv) {
                return pv + cv;
              }, 0)
            }}
            Tage
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

  <script>
import axios from "axios";
import DiagrammItem from "../DiagrammItem";

export default {
  components: { DiagrammItem },

  data() {
    const ThisYear = new Date().getFullYear();
    return {
      userdata: undefined,
      show: "full",
      shows: [
        {
          text: "ganzes Jahr",
          value: "full",
        },
        {
          text: "Halbjahren",
          value: "half",
        },
        {
          text: "Quartalen",
          value: "quartel",
        },
      ],
      skills: [],
      dialog: false,
      height: this.$vuetify.breakpoint.height,
      diagrammItem: undefined,
      department: [],
      workDays: [],
      search: "",
      ist_datenSum: [],
      soll_datenSum: [],
      precent_data: [],
      nameFilterValue: "",
      skillFilterValue: null,
      departmentFilterValue: null,

      myloadingvariable: true,
      headers1: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: false,
          width: "auto",
          filter: this.nameFilter,
        },

        {
          text: "Abteilung",
          align: "left",
          value: "department",
          sortable: false,
          width: "auto",
          filter: this.departmentFilter,
        },
        {
          text: "Skill",
          align: "left",
          value: "skill",
          sortable: true,
          width: "auto",
          filter: this.skillFilter,
        },
        {
          text: "Dim.",
          align: "left",
          sortable: false,
          width: "auto",
        },

        {
          text: ThisYear - 3,
          value: "forecast_daten['2018']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 2,
          value: "forecast_daten['2019']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 1,
          value: "forecast_daten['2020']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear,
          value: "forecast_daten['2021']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },

        {
          text: "Sum",
          align: "left",
          sortable: true,
          width: "auto",
        },
      ],
      headers2: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: false,
          width: "auto",
          filter: this.nameFilter,
        },

        {
          text: "Abteilung",
          align: "left",
          value: "department",
          sortable: false,
          width: "auto",
          filter: this.departmentFilter,
        },
        {
          text: "Skill",
          align: "left",
          value: "skill",
          sortable: true,
          width: "auto",
          filter: this.skillFilter,
        },
        {
          text: "Dim.",
          align: "left",
          sortable: false,
          width: "auto",
        },

        {
          text: ThisYear - 3 + "/1",
          value: "forecast_daten['2018']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 3 + "/2",
          value: "forecast_daten['2018']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 2 + "/1",
          value: "forecast_daten['2019']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 2 + "/2",
          value: "forecast_daten['2019']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 1 + "/1",
          value: "forecast_daten['2020']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 1 + "/2",
          value: "forecast_daten['2020']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear + "/1",
          value: "forecast_daten['2020']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear + "/2",
          value: "forecast_daten['2020']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },

        {
          text: "Sum",
          align: "left",
          sortable: true,
          width: "auto",
        },
      ],
      headers3: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: false,
          width: "auto",
          filter: this.nameFilter,
        },

        {
          text: "Abteilung",
          align: "left",
          value: "department",
          sortable: false,
          width: "auto",
          filter: this.departmentFilter,
        },
        {
          text: "Skill",
          align: "left",
          value: "skill",
          sortable: true,
          width: "auto",
          filter: this.skillFilter,
        },
        {
          text: "Dim.",
          align: "left",
          sortable: false,
          width: "auto",
        },

        {
          text: ThisYear - 3 + "/1",
          value: "forecast_daten['2018']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 3 + "/2",
          value: "forecast_daten['2018']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 3 + "/3",
          value: "forecast_daten['2018']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 3 + "/4",
          value: "forecast_daten['2018']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },

        {
          text: ThisYear - 2 + "/1",
          value: "forecast_daten['2019']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 2 + "/2",
          value: "forecast_daten['2019']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 2 + "/3",
          value: "forecast_daten['2019']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 2 + "/4",
          value: "forecast_daten['2019']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 1 + "/1",
          value: "forecast_daten['2020']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 1 + "/2",
          value: "forecast_daten['2020']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 1 + "/3",
          value: "forecast_daten['2020']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear - 1 + "/4",
          value: "forecast_daten['2020']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear + "/1",
          value: "forecast_daten['2020']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear + "/2",
          value: "forecast_daten['2020']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear + "/3",
          value: "forecast_daten['2020']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },
        {
          text: ThisYear + "/4",
          value: "forecast_daten['2020']",
          align: "left",
          sortable: false,
          width: "auto",
          class: "deep-orange--text",
        },

        {
          text: "Sum",
          align: "left",
          sortable: true,
          width: "auto",
        },
      ],
    };
  },
  created() {
    axios
      .get(`/forecast/department`)
      .then((res) => {
        this.department = res.data.departments;
        this.department.push("");
        this.skills = res.data.skills;
      })
      .catch((error) => console.log(error.response.data));

    axios;
    axios
      .get(`/forecast/compile`, { params: { show: this.show } })
      .then((res) => {
        this.userdata = res.data;
      })
      .catch((error) => (this.error = error.response.data.errors));
  },

  computed: {
    headers() {
      switch (this.show) {
        case "full":
          return this.headers1;
        case "half":
          return this.headers2;
        case "quartel":
          return this.headers3;
      }
    },
    yearsHeaders() {
      var arr = [];
      var x = this.year;
      for (let i = 0; i <= 4; i++) {
        arr[i] = x;
        x = x - 1;
      }
      conslol.log(arr);
      return arr;
    },
  },
  methods: {
    diagramm(item) {
      EventBus.$emit("diagrammUpdate", { item: item, headers: this.headers });
      this.diagrammItem = { item: item, headers: this.headers };
      this.dialog = true;
    },
    changeShow(e) {
      this.show = e;
      this.userdata = undefined;
      axios
        .get(`/forecast/compile`, { params: { show: this.show } })
        .then((res) => {
          this.userdata = null;
          this.userdata = res.data;
          this.datenSum;
        })
        .catch((error) => (this.error = error.response.data.errors));
    },

    datenSum(e) {
      let i;
      var is_datenSum0 = [];
      var soll_datenSum0 = [];

      for (i = 0; i < Object.keys(e).length; i++) {
        is_datenSum0[i] = e[i].forecast_daten;
        soll_datenSum0[i] = e[i].soll_daten;
      }

      if (this.userdata) {
        this.ist_datenSum = is_datenSum0[0].map((x, idx) =>
          is_datenSum0.reduce((sum, curr) => sum + curr[idx], 0)
        );
        this.soll_datenSum = soll_datenSum0[0].map((x, idx) =>
          soll_datenSum0.reduce((sum, curr) => sum + curr[idx], 0)
        );
        var j = 0;
        switch (this.show) {
          case "full":
            j = 4;
            this.precent_data = this.precent_data.slice(0, 4);
            break;
          case "half":
            j = 8;
            this.precent_data = this.precent_data.slice(0, 8);
            break;
          case "quartel":
            j = 16;
            this.precent_data = this.precent_data.slice(0, 8);
            break;
        }
        for (i = 0; i < j; i++) {
          this.precent_data[i] =
            (this.ist_datenSum[i] * 100) / this.soll_datenSum[i];
        }
      }
      if (this.userdata) {
        this.workDays = this.userdata[1].workDays;
      }
    },
    sumField(key) {
      // sum data in give key (property)
      return this.userdata.reduce((a, b) => a + (b[key] || 0), 0);
    },
    nameFilter(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.nameFilterValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.nameFilterValue.toLowerCase());
    },
    skillFilter(value) {
      if (!this.skillFilterValue) {
        return true;
      }
      return value.toLowerCase().includes(this.skillFilterValue.toLowerCase());
    },
    departmentFilter(value) {
      if (!this.departmentFilterValue) {
        return true;
      }

      return value
        .toLowerCase()
        .includes(this.departmentFilterValue.toLowerCase());
    },

    loading() {
      if (userdata) {
        this.myloadingvariable = true;
      }
    },
  },
};
</script>
<style scoped>
.v-data-table >>> header {
  font-size: 0.8em;
  font-weight: 100;
  text-transform: capitalize;
}
.v-text-field >>> input {
  font-size: 0.8em;
  font-weight: 100;
  text-transform: capitalize;
}
</style>